module.exports = "<app-partdetails *ngIf=\"isDataLoaded\" [viewData]=partDetails></app-partdetails>"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-app/part/part.component.html
// module id = ./src/opc/opc-app/part/part.component.html
// module chunks = main